import { useMutation } from "@tanstack/react-query"

import { axiosClient } from "$/http"

import { Urls } from "../urls"

type Options = {
    coacheeId: number
    participantId: number
}

export function useCreateConversation() {
    return useMutation({
        mutationFn: ({ coacheeId, participantId }: Options) =>
            axiosClient.post<{ id: number }>(Urls.conversation(), { coachee: coacheeId, participant: participantId })
    })
}
